import React, { useState, useEffect } from "react";
import {
  VodToolTipWrapper,
  VodToolTipHeading,
  VodToolTipMessage,
  VodToolTipArrow,
  VodToolTipCloseButton,
  VodToolTipHeaderWrapper,
} from "./VODToolTip.styles";
import { useTheme } from "styled-components";
import { IsSafari } from "../../shared/utils";

const closeButton = process.env.PUBLIC_URL + "/images/tooltip_close.svg";

const VODToolTip = ({ tooltipMessages, handleClose, isVodToolTipActive }) => {
  const theme = useTheme();
  const [currentIndex, setCurrentIndex] = useState(0);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const isSafari = IsSafari();

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [screenWidth]);

  if (!tooltipMessages || tooltipMessages.length === 0) {
    return null;
  }

  return tooltipMessages[currentIndex] ? (
    <VodToolTipWrapper theme={theme} position={tooltipMessages[currentIndex].position} isSafari={isSafari}>
      <VodToolTipArrow theme={theme} position={tooltipMessages[currentIndex].position}></VodToolTipArrow>
      <VodToolTipHeaderWrapper>
        <VodToolTipHeading>{tooltipMessages[currentIndex].tooltipHeader}</VodToolTipHeading>
        <VodToolTipCloseButton src={closeButton} onClick={handleClose} />
      </VodToolTipHeaderWrapper>
      <VodToolTipMessage $isVodToolTipActive={isVodToolTipActive}>
        {tooltipMessages[currentIndex].tooltipText}
      </VodToolTipMessage>
    </VodToolTipWrapper>
  ) : null;
};

export default VODToolTip;
